import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    mode: "panel", // panel or editor
    isMainNavOpen: true,
  }),
  actions: {
    setMode(mode) {
      this.mode = mode;
    },
  },
});
